<script>
    export let user;
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: var(--spacer-medium);
        padding-bottom: 0;
        margin-bottom: var(--spacer-xlarge);
    }

    a {
        text-decoration: none;
    }

    h1 {
        font-size: var(--font-regular);
        font-weight: var(--weight-bold);
        color: var(--color-orange);

        @include sm {
            font-size: var(--font-large);
        }
    }

    div {
        display: flex;
        align-items: baseline;

        a {
            margin-left: 16px;
        }
    }

    .announcement {
        background-color: #f87e7a;
        width: 100vw;
        position: fixed;
        left: 50%;
        right: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
        display: flex;
        justify-content: center;
        z-index: 1;
        padding: var(--spacer-tiny) 0;

        p {
            text-align: center;
            font-size: var(--font-small);

            @include sm {
                font-size: inherit;
            }

            a {
                margin-left: 0;
            }
        }
    }
</style>

<div class="announcement">
    <p>
        <strong>Important</strong>: We have decided to stop working on
        cofounder.chat, you can read more about why
        <a href="https://alexandar.me/cofounder.chat">here</a>.
    </p>
</div>

<nav>
    <a href="/"><h1>cofounder.chat</h1></a>

    <div>
        {#if user}
            <a href="/account">Account</a>
        {:else}<a href="/signin">Login</a>{/if}
    </div>
</nav>
